import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tours-page03',
  templateUrl: './tours-page03.component.html',
  styleUrls: ['./tours-page03.component.css']
})
export class ToursPage03Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
